import type { AttendanceState, StampKind } from '@wf/shared'
import { ApiError } from '../api/client'
import { stampErrorText } from '../attendance/stampError'
import { useStamp } from '../attendance/useAttendance'

/**
 * Großes Stempel-Pad (Design 1a): je Zustand nur die sinnvollen Aktionen — aus→„Kommen" (volle Breite),
 * an→„Pause"+„Gehen", pause→„Pause beenden"+„Gehen". Teilt Hook/OCC-Version mit der Header-Uhr;
 * 409 (anderes Gerät hat gestempelt) zeigt den bekannten Reconcile-Hinweis.
 */
export function BigStampPad({ state }: { state: AttendanceState }) {
  const stamp = useStamp()
  const click = (kind: StampKind): void => stamp.mutate({ kind, version: state.version })
  const busy = stamp.isPending
  const conflict = stamp.error instanceof ApiError && stamp.error.status === 409

  return (
    <div className="wf-zspad">
      {state.status === 'aus' ? (
        <button type="button" className="wf-btn wf-btn--primary wf-zspad__main" onClick={() => click('kommen')} disabled={busy}>
          Kommen
        </button>
      ) : null}
      {state.status === 'an' ? (
        <div className="wf-zspad__row">
          <button type="button" className="wf-btn wf-zspad__pause" onClick={() => click('pause_start')} disabled={busy}>
            Pause
          </button>
          <button type="button" className="wf-btn wf-btn--ghost wf-zspad__go" onClick={() => click('gehen')} disabled={busy}>
            Gehen
          </button>
        </div>
      ) : null}
      {state.status === 'pause' ? (
        <div className="wf-zspad__row">
          <button type="button" className="wf-btn wf-zspad__resume" onClick={() => click('pause_ende')} disabled={busy}>
            Pause beenden
          </button>
          <button type="button" className="wf-btn wf-btn--ghost wf-zspad__go" onClick={() => click('gehen')} disabled={busy}>
            Gehen
          </button>
        </div>
      ) : null}
      {conflict ? (
        <p className="hint" role="status">
          {stampErrorText(stamp.error)}
        </p>
      ) : null}
      {stamp.isSuccess && stamp.data?.result === 'converted' ? (
        <p className="hint" role="status">
          Zu spät zum direkten Stempeln — als Korrekturantrag eingereicht. Dein Chef gibt ihn frei.
        </p>
      ) : null}
    </div>
  )
}
